import useSWRInfinite from 'swr/infinite';
import { getFlexStartAndEndDate } from '../helpers/getFlexStartAndEndDate';
import { FlexCalSummary, Opening } from '../types';

const useInfiniteOpenings = (
  flexCal: FlexCalSummary,
  setIsReachingEnd: React.Dispatch<React.SetStateAction<boolean>>,
  apiUri: string
) => {
  const TWO_WEEKS_IN_MILLIS = 1209600000;
  const { start, end } = getFlexStartAndEndDate(flexCal);
  const totalPages = Math.ceil(end.diff(start, ['weeks']).weeks / 2);
  const getKey = (pageIndex: number) => {
    if (pageIndex >= totalPages) return null;
    const addToStart = pageIndex * TWO_WEEKS_IN_MILLIS;
    const addToEnd = addToStart + TWO_WEEKS_IN_MILLIS;
    const endDate = start.plus({ milliseconds: addToEnd });
    const startDate = start.plus({ milliseconds: addToStart });

    const encodedStartDate = encodeURIComponent(
      startDate.toFormat('MM/dd/yyyy, h:mm a')
    );
    const encodedEndDate = encodeURIComponent(
      endDate.toFormat('MM/dd/yyyy, h:mm a')
    );
    return `${apiUri}/lazycalendar/getAvailableTimes/${flexCal.lazyCalendarId}?startDate=${encodedStartDate}&endDate=${encodedEndDate}`;
    // return `${apiUri}/lazycalendar/getAvailableTimes/${
    //   flexCal.lazyCalendarId
    // }?startDate=${startDate.toFormat(
    //   'MM/dd/yyyy, h:mm a'
    // )}&endDate=${endDate.toFormat('MM/dd/yyyy, h:mm a')}`;
  };
  const { data, error, mutate, size, setSize, isValidating } = useSWRInfinite<
    Opening[]
  >(getKey, { revalidateFirstPage: false });
  const openings = data ? ([] as Opening[]).concat(...data) : [];
  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData ||
    (size > 0 && data && typeof data[size - 1] === 'undefined');
  const isEmpty = data?.[0]?.length === 0;
  const isRefreshing = isValidating && data && data.length === size;
  const currentLoadedPage = data?.length ? data.length : 0;
  return {
    openings,
    isLoadingInitialData,
    isLoadingMore,
    isEmpty,
    isRefreshing,
    mutate,
    size,
    setSize,
    currentLoadedPage,
  };
};

export default useInfiniteOpenings;
